<script setup lang="ts">
import {useCachedMainNavigation} from "~/components/server/useCachedMainNavigation";
import HeaderTop from "../components/layout/HeaderTop.vue";

defineOptions({
  name: "DefaultLayout",
});

const route = useRoute()
const {getAbsoluteUrl}=useAbsoluteUrl();
useHead({
  link: [
    {
      rel: 'canonical',
      href: getAbsoluteUrl(route.path),
    },
  ]
});

// Navigation for default theme (depth 1 is 2 level navi, depth 2 is 3 level navi, and so on)
const { data } = useAsyncData("mainNavigation", () => {
  return useCachedMainNavigation (1, "main-navigation");
});
provide("swNavigation-main-navigation", data);

const { data: footerData } = useAsyncData("mainFooterNavigation", () => {
  return useCachedMainNavigation (1, "footer-navigation");
});
provide("swNavigation-footer-navigation", footerData);

const { data: topNavigationData } = useAsyncData( "mainServiceNavigation", ()=> {
  return useCachedMainNavigation (1, "service-navigation");
})
provide("swNavigation-service-navigation", topNavigationData)

const miniCartModal = useMiniCartModal();
</script>
<template>
  <main class="overflow-x-clip">
    <HeaderTop />
    <LayoutHeader />
    <CheckoutSideCart :controller="miniCartModal" />
    <div class="wrapper-inner">
      <LayoutNotifications />
      <main class="mx-auto min-h-[750px] md:min-h-[520px]">
        <slot />
      </main>
      <LayoutFooter />
    </div>
  </main>
</template>
